let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7cWhH")).then(() => parcelRequire('hUEbu'));